import { hasPermission, getPermissionName } from "@/permission";

const routePerms = vm => {
  const list = vm.$route.path.split("/");
  list.splice(0, 1);
  return list.join(":");
};

export default {
  bind(el, binding, vnode) {
    const vm = vnode.context;
    const key = binding.value;
    if (!key) return;
    if (!hasPermission(routePerms(vm) + ":" + key)) {
      el.style.display = "none";
    }
    const label = getPermissionName(routePerms(vm) + ":" + key);
    if (el.tagName === "BUTTON" && label) {
      let target = el;
      while (target.lastChild) {
        target = target.lastChild;
      }
      target.textContent = label;
    }
  }
};
